module.exports = __webpack_public_path__ + "static/media/autokar2 (5).d7917d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (5).jpg
// module id = 852
// module chunks = 0